<template>
  <div>
    <celebrate-graphics title="What Next">
      <template slot="content">
        <p class="text">
          Thank you for referring the below applicants. If they accept your referral
          and are hired, you'll earn a VIBES Reward based on the job's salary or
          pay. You can review your referrals in the Referrals section.
        </p>
      </template>
    </celebrate-graphics>
    <divider/>
    <heading>Jobseekers</heading>
    <div class="selections">
      <referral-card
        class="jobseeker-card"
        v-for="(item, index) in selected"
        :key="index"
        :item="item"
      />
    </div>
    <divider/>
    <heading>REFERRAL REWARD (YOU)</heading>
    <div class="reward">
      <div>
        <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="job.rewardPercentage" cssClass="inline normal f-14" title="in HVT *" :referrer="true" />
      </div>
    </div>
    <divider/>
    <heading>Jobseeker REWARD</heading>
    <div class="reward">
      <div>
        <reward :min="referrerRewardMin" :max="referrerRewardMax" :rewardPercentage="job.rewardPercentage" cssClass="inline normal f-14" title="in HVT *" :referrer="true" />
      </div>
    </div>
    <divider/>
    <heading>* HVT Terms</heading>
    <p class="text">
     HVT prices are variable. The HVT reward will be calculated at each interval.
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import ReferralCard from '@/components/referrals/referral-card'
import Currency from '@/components/general/currency'
import CelebrateGraphics from '@/components/general/celebrate-graphics'
import Reward from '@/components/jobs/reward'
import GlobalData from '@/helpers/global-data'
import RewardHelper from '@/helpers/reward'

export default {
  components: {
    ReferralCard,
    Divider,
    Heading,
    Currency,
    CelebrateGraphics,
    Reward
  },
  computed: {
    ...mapState('jobReferral', ['selected', 'job']),
    referralFraction () {
      return GlobalData.referralFraction()
    },
    referrerReward () {
      const reward = this.job.usdReward * this.referralFraction
      return isNaN(reward) ? 0 : reward
    },
    referrerRewardMin () {
      return RewardHelper.user(this.job.minReward, this.job.rewardPercentage) * this.referralFraction
    },
    referrerRewardMax () {
      return RewardHelper.user(this.job.maxReward, this.job.rewardPercentage) * this.referralFraction
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.is-right {
  color: #888;
}
.heading {
  margin-bottom: 0.5rem;
}
.card.jobseeker-card {
  cursor: pointer;
}

.card.jobseeker-card:hover {
  background-color: $hover-background;
}

.card.jobseeker-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.jobseeker-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.reward {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/referral-confirmation.vue